// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Nz-z","modalContent":"Oz-z","header":"Pz-z","close":"Qz-z"};